export default {
  stats: {
    orders: 'Tilaukset',
    sales: 'Liikevaihto',
  },
};
